import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Login = () => {
    //define state register
    const [name_reg, setName] = useState("");
    const [email_reg, setEmail] = useState("");
    const [ig_reg, setIg] = useState("");
    const [tiktok_reg, setTiktok] = useState("");
    const [password_reg, setPassword] = useState("");
    const [passwordConfirmation, setPasswordConfirmation] = useState("");

    //define state validation
    const [validation, setValidation] = useState([]);

    //define navigate
    const navigate = useNavigate();

    //function "registerHanlder"
    const registerHandler = async (e) => {
        e.preventDefault();

        //initialize formData
        const formData = new FormData();

        //append data to formData
        formData.append('name_reg', name_reg);
        formData.append('email_reg', email_reg);
        formData.append('ig_reg', ig_reg);
        formData.append('tiktok_reg', tiktok_reg);
        formData.append('password_reg', password_reg);
        formData.append('password_confirmation', passwordConfirmation);

        //send data to server
        await axios.post('https://dev.jftheskinspecialist.com/api/register', formData)
            .then(() => {

                //redirect to logi page
                navigate('/successreg');
            })
            .catch((error) => {

                //assign error to state "validation"
                setValidation(error.response.data);
            })
    };

    const [email, setEmailLogin] = useState("");
    const [password, setPasswordLogin] = useState("");


    //function "loginHanlder"
    const loginHandler = async (e) => {
        e.preventDefault();

        //initialize formData
        const formData = new FormData();

        //append data to formData
        formData.append('email', email);
        formData.append('password', password);

        //send data to server
        await axios.post('https://dev.jftheskinspecialist.com/api/login', formData)
            .then((response) => {

                //set token on localStorage
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('user_loginset', response.data.user.name);
                localStorage.setItem('user_emailset', response.data.user.email);

                //redirect to 
                navigate('/dashboard');
                window.location.reload();
            })
            .catch((error) => {

                //assign error to state "validation"
                setValidation(error.response.data);
            })
    };

    //hook useEffect
    useEffect(() => {

        //check token
        if (localStorage.getItem('token')) {

            //redirect page 
            navigate('/dashboard');
        }
    }, []);

    return (
        <div className="max-w-12xl mx-auto">
            <div class="max-w-full mx-auto p-4">
                <h1 class="text-3xl font-semibold text-[#f26821]">MY ACCOUNT</h1>
                <hr class="border-t-2 border-[#f26821] my-4" />
                {
                    validation.message && (
                        <div className="alert alert-danger">
                            {validation.message}
                        </div>
                    )
                }

                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div class="border border-[#f26821] p-6 rounded-md bg-[#fff5e0]">
                            <h2 class="text-2xl font-semibold text-[#f26821] mb-4">LOGIN</h2>
                            
                            <form onSubmit={loginHandler}>
                                <label class="block text-[#f26821] font-semibold mb-2" for="username">Email address *</label>
                                <input class="w-full border border-[#f26821] rounded-sm p-2 mb-4" type="email" id="email" value={email} onChange={(e) => setEmailLogin(e.target.value)} placeholder="Masukkan Alamat Email" required />
                                {
                                    validation.email && (
                                        <div className="alert alert-danger">
                                            {validation.email[0]}
                                        </div>
                                    )
                                }

                                <label class="block text-[#f26821] font-semibold mb-2" for="password">Password *</label>
                                <input class="w-full border border-[#f26821] rounded-sm p-2 mb-4" type="password" id="password_login" value={password} onChange={(e) => setPasswordLogin(e.target.value)} placeholder="Masukkan Password" required />
                                {
                                    validation.password && (
                                        <div className="alert alert-danger">
                                            {validation.password[0]}
                                        </div>
                                    )
                                }

                                <div class="flex items-center mb-4">
                                    <input type="checkbox" id="remember" name="remember" class="h-4 w-4 text-[#f26821] border-gray-300 rounded" />
                                        <label for="remember" class="ml-2 text-[#555555]">Remember me</label>
                                </div>

                                <button type="submit" class="w-full bg-[#f26821] text-white font-semibold py-2 rounded-sm">LOGIN</button>

                                <a href="#" class="text-[#f26821] text-sm mt-4 inline-block">Lost your password?</a>
                            </form>
                        </div>

                        <div class="border border-[#f26821] p-6 rounded-md bg-[#fff5e0]">
                            <h2 class="text-2xl font-semibold text-[#f26821] mb-4">REGISTER</h2>
                            <form onSubmit={registerHandler}>
                                    <label class="block text-[#f26821] font-semibold mb-2" for="fullname">Full name *</label>
                                    <input class="w-full border border-[#f26821] rounded-sm p-2 mb-4" type="text" id="fullname" value={name_reg} onChange={(e) => setName(e.target.value)} placeholder='Masukan Nama Lengkap' />
                                    {
                                        validation.name_reg && (
                                            <div className="alert alert-danger">
                                                {validation.name_reg[0]}
                                            </div>
                                        )
                                    }
                                    <label class="block text-[#f26821] font-semibold mb-2" for="email">Email address *</label>
                                    <input class="w-full border border-[#f26821] rounded-sm p-2 mb-4" type="email" id="email_reg" value={email_reg} onChange={(e) => setEmail(e.target.value)} placeholder='Masukan Email' />
                                    {
                                        validation.email_reg && (
                                            <div className="alert alert-danger">
                                                {validation.email_reg[0]}
                                            </div>
                                        )
                                    }

                                    <label class="block text-[#f26821] font-semibold mb-2" for="email">IG Name (optional)</label>
                                    <input class="w-full border border-[#f26821] rounded-sm p-2 mb-4" type="text" id="ig_reg" value={ig_reg} onChange={(e) => setIg(e.target.value)} placeholder='Masukan Nama IG' />
                                    {
                                        validation.ig_reg && (
                                            <div className="alert alert-danger">
                                                {validation.ig_reg[0]}
                                            </div>
                                        )
                                    }

                                    <label class="block text-[#f26821] font-semibold mb-2" for="email">Tiktok Name (optional)</label>
                                    <input class="w-full border border-[#f26821] rounded-sm p-2 mb-4" type="text" id="tiktok_reg" value={tiktok_reg} onChange={(e) => setTiktok(e.target.value)} placeholder='Masukan Nama Tiktok' />
                                    {
                                        validation.tiktok_reg && (
                                            <div className="alert alert-danger">
                                                {validation.tiktok_reg[0]}
                                            </div>
                                        )
                                    }

                                    <label class="block text-[#f26821] font-semibold mb-2" for="reg-password">Password *</label>
                                    <input class="w-full border border-[#f26821] rounded-sm p-2 mb-4" type="password" id="reg-password" value={password_reg} onChange={(e) => setPassword(e.target.value)} placeholder='Masukan Password' />
                                    {
                                        validation.password_reg && (
                                            <div className="alert alert-danger">
                                                {validation.password_reg[0]}
                                            </div>
                                        )
                                    }

                                    <label class="block text-[#f26821] font-semibold mb-2" for="reg-password">KONFIRMASI PASSWORD</label>
                                    <input type="password" class="w-full border border-[#f26821] rounded-sm p-2 mb-4" value={passwordConfirmation} onChange={(e) => setPasswordConfirmation(e.target.value)} placeholder="Masukkan Konfirmasi Password" />

                                    <button type="submit" class="w-full bg-[#f26821] text-white font-semibold py-2 rounded-sm">REGISTER</button>
                            </form>
                        </div>
                    </div>
            </div> <br />
        </div>
    );
};

export default Login;
